<template>
  <div class="ypo-event-filters relative-position" v-if="filterList && filterList.length">
    <v-expansion-panel :expand="true" class="ypo-event-filters__accordion" :value="accordionState">
      <v-expansion-panel-content v-for="(filterFacet, index) in filterList" :key="index">
        <div slot="header" :data-qe-id="`event-facet-${index}`">
          {{filterFacet.title}}
        </div>
        <div v-if="filterFacet.categories && filterFacet.categories.length">
          <div v-if="isLocationFilter(filterFacet)">
            <ypo-events-location-filter :location-filter="getLocationFilters(filterFacet, appliedLocationFilters)"
                                        :applied-location-filters="appliedLocationFilters"
                                        :set-most-recent-facet-in-state="setMostRecentFacetInState"
                                        :all-applied-filters="selectedFilterState">
            </ypo-events-location-filter>
          </div>
          <div v-if="isHostFilter(filterFacet)">
            <ypo-events-host-filter     :host-filter="filterFacet"
                                        :all-applied-filters="selectedFilterState"
                                        :applied-host-filters="appliedHostFilters"
                                        :set-most-recent-facet-in-state="setMostRecentFacetInState">
                                        
            </ypo-events-host-filter>
          </div>
          <div v-if="isDateFilter(filterFacet)">
            <ypo-events-date-filter :date-filter-facet="filterFacet"
                                    :applied-date-filters="appliedDateFilters"
                                    :set-most-recent-facet-in-state="setMostRecentFacetInState"
                                    :all-applied-filters="selectedFilterState">
            </ypo-events-date-filter>
          </div>
          <div v-if="isMyCommunityFilter(filterFacet)">
            <v-layout column wrap v-for="(filterCategory, idx) in filterFacet.categories" :key="idx">
              <v-flex xs12 ml-3 class="filter-category">
                <label class="check-container ypo_blue_color check-container--radio">
                  <v-layout>
                    <v-flex class="check-container--label"
                            :data-qe-id="`event-facet-${index}_category-${idx}`">
                      <span :class="[filterCategory.checked ? 'checked-option' : '']">{{filterCategory.label}}</span>
                    </v-flex>
                  </v-layout>
                  <input type="radio"
                         :value="filterCategory"
                         v-model="localFilters"
                         :name="filterCategory.filterKey"
                         @change="applyFilter(filterCategory, filterFacet.key)"
                         :data-qe-id="`event-facet-${index}_category-${idx}_input`">
                  <span class="checkmark" :class="[filterCategory.checked ? 'checked-checkbox' : '']"></span>
                </label>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="isGeneralFilter(filterFacet)">
            <v-layout column wrap v-for="(filterCategory, idx) in filterFacet.categories" :key="idx">
              <v-flex xs12 ml-3 class="filter-category">
                <label class="check-container ypo_blue_color">
                  <v-layout>
                    <v-flex class="check-container--label"
                            :data-qe-id="`event-facet-${index}_category-${idx}`">
                      <span :class="[filterCategory.checked ? 'checked-option' : '']">{{filterCategory.label}}</span>
                    </v-flex>
                  </v-layout>
                  <input type="checkbox"
                         :value="filterCategory"
                         v-model="localFilters"
                         @change="applyFilter(filterCategory, filterFacet.key)"
                         :data-qe-id="`event-facet-${index}_category-${idx}_input`">
                  <span class="checkmark" :class="[filterCategory.checked ? 'checked-checkbox' : '']"></span>
                </label>
              </v-flex>              
            </v-layout>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import {
  ypoEventConstant,
  getAccordionState,
  getLocationFilters,
  getUpdatedFiltersToApply,
  getFilteredString
} from "@/components/YpoEvents/ypoEvents.constant";
import YpoEventsLocationFilter from "@/components/YpoEvents/YpoEventsLocationFilter";
import YpoEventsDateFilter from "@/components/YpoEvents/YpoEventsDateFilter";
import YpoEventsHostFilter from "@/components/YpoEvents/YpoEventsHostFilter";
import {gaDataLayerEvent} from "@/plugins/analytics";
import {gtmEventName} from "@/plugins/gtmAnalytics";

export default {
  name: 'YpoEventFilters',
  components: {
    YpoEventsLocationFilter,
    YpoEventsDateFilter,
    YpoEventsHostFilter,
   },
  props: {
    filterList: {
      type: Array,
      required: true,
    },
    selectedFilterState: {
      type: Object,
      required: true,
    },
    setMostRecentFacetInState: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      ypoEventConstant,
      localAccordionState: [],
      localFilters: [],
      localSubFilters: [],
    };
  },
  methods: {
    getLocationFilters,
    applyFilter(filterItem, parentKey) {
      const filtersFromRoute = this.$route && this.$route.query && this.$route.query.eventFilters
          ? JSON.parse(this.$route.query.eventFilters)
          : null;
      const filterToPush = getUpdatedFiltersToApply(filterItem, parentKey, filtersFromRoute);

      if (this.setMostRecentFacetInState) this.setMostRecentFacetInState(parentKey);
      const gtmFilters = getFilteredString(filterToPush) ;
      gaDataLayerEvent(gtmEventName.C_Event_Search_Filters, gtmFilters);
      this.$router.push({
        query: {
          ...this.$route.query,
          eventFilters: JSON.stringify(filterToPush),
        },
      });
    },
    isLocationFilter(facet) {
      return !!(facet && facet.key && facet.key === ypoEventConstant.constant.keys.locationFilter);
    },
    isHostFilter(facet) {
      return !!(facet && facet.key && facet.key === ypoEventConstant.constant.keys.hostFilter);
    },
    isDateFilter(facet) {
      return !!(facet && facet.key && facet.key === ypoEventConstant.constant.keys.datesFilter);
    },
    isMyCommunityFilter(facet) {
      return !!(facet && facet.key && (facet.key === ypoEventConstant.constant.keys.myNetworks || facet.key === ypoEventConstant.constant.keys.myChapters));
    },
    isGeneralFilter(facet) {
      return !this.isLocationFilter(facet) && !this.isDateFilter(facet) && !this.isHostFilter(facet) && !this.isMyCommunityFilter(facet);
    }
  },
  computed: {
    accordionState() {
      return getAccordionState(this.filterList);
    },
    appliedLocationFilters() {
      return this.selectedFilterState
      && this.selectedFilterState.hasOwnProperty(ypoEventConstant.constant.keys.locationFilter)
          ? this.selectedFilterState[ypoEventConstant.constant.keys.locationFilter]
          : [];
    },
    appliedDateFilters() {
      return this.selectedFilterState
      && this.selectedFilterState.hasOwnProperty(ypoEventConstant.constant.keys.datesFilter)
          ? this.selectedFilterState[ypoEventConstant.constant.keys.datesFilter]
          : [];
    },
    appliedHostFilters() {
      return this.selectedFilterState
      && this.selectedFilterState.hasOwnProperty(ypoEventConstant.constant.keys.hostFilter)
          ? this.selectedFilterState[ypoEventConstant.constant.keys.hostFilter]
          : [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-event-filters {
  padding-right: 15px;

  &__accordion {
    border: none !important;
    box-shadow: none !important;
  }

  .filter-category {
    @extend %ypo-secondary-checkbox;
  }
}
</style>
<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.ypo-event-filters {
  &__accordion {
    .v-expansion-panel__header {
      padding: 7px 5px !important;
      min-height: 30px !important;
      font-size: 12px;
      text-transform: uppercase;
      :hover{
        text-decoration: underline;
      }

      > div {
        flex: 0 1 auto !important;
      }

      &__icon {
        margin-top: 2px;
        margin-left: 5px;
        text-decoration: none !important;     
        
        i {
          text-decoration: none !important;
          font-size: 18px;            
        }
      }
    }
    .sub-filter-layout {
      margin-left: 28px;
    }

    .v-expansion-panel__container {
      border-top: 1px solid $ypo-solitude-gray !important;
      border-bottom: 1px solid $ypo-solitude-gray !important;
      margin-bottom: -1px !important;

      &--active {
        border-color: $ypo-tower-gray-border !important;
        border-top: 1px solid $ypo-tower-gray-border !important; 
        border-bottom: 1px solid $ypo-tower-gray-border !important;

        .v-expansion-panel__header {
          font-weight: 700 !important;
          color: $black !important;
        }
      }
    }
  }
}
</style>
